import { useContext } from 'react';

import IconButton from '@mui/material/IconButton';

import { ArrowBack } from '@mui/icons-material';
import { SearchComponent } from '@/components/common/Search';

import './Header.css';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { useTranslation } from 'react-i18next';
import { ctxMessages } from '@/contexts/MessagesCtx';

export function Header() {
  const ctx = useContext(ctxMessages);
  const { t } = useTranslation();

  if (!ctx) return;

  function navigateBack() {
    ctx?.setThread(undefined);
  }

  if (isPhoneOrHighScreen() && ctx.thread) {
    return (
      <>
        <div className="chat-thread-header">
          <span className="left">
            <IconButton onClick={navigateBack} sx={{ color: 'text.primary' }}>
              <ArrowBack />
            </IconButton>
          </span>
          <div className="chat-thread-name">
            <div>{ctx.thread.user.name}</div>
            <div className="chat-thread-description">{ctx.thread.user.description}</div>
          </div>
          <span className="right"></span>
        </div>
      </>
    );
  } else {
    return (
      <>
        {!isPhoneOrHighScreen() && <h3>{t('chat.latestMessages')}</h3>}
        <SearchComponent searchText={ctx.searchText} setSearchText={ctx.setSearchText} />
      </>
    );
  }
}
